<script>
export default {
  mounted() {
    document.body.className = ''
  }
}
</script>

<template>
  <div class="shell">
    <div class="shell-header">
      <div class="wrapper">
        <slot name="header" />
      </div>
    </div>
    <div class="shell-content">
      <div class="wrapper">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/_functions.scss';
@import '@/styles/_settings.scss';

.shell {
}

.shell-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: white;

  height: 80px;
  // background: $gray-100;
  border-bottom: 1px solid $gray-400;
}

.shell-content {
  margin-top: 95px;
}
</style>
